import {
  GroupType,
  OrganisationGroup
} from '../../../../common/api/spidertracks-sdk/private/services/UserService';

export const getSelectedGroupNamesForLabels = (
  selectedGroupIds: string[],
  orgGroups: OrganisationGroup[]
): string[] => {
  const allUsersGroupId = orgGroups.find(orgGroup => orgGroup.type === GroupType.ALL_USERS)?.id;
  const allAdminsGroupId = orgGroups.find(orgGroup => orgGroup.type === GroupType.ALL_ADMINS)?.id;

  const selectedGroupNames = orgGroups
    .filter(
      orgGroup => orgGroup.type !== GroupType.ALL_USERS && orgGroup.type !== GroupType.ALL_ADMINS
    )
    .filter(orgGroup => selectedGroupIds.includes(orgGroup.id))
    .map(orgGroup => orgGroup.name);
  if (allUsersGroupId && selectedGroupIds.includes(allUsersGroupId)) {
    selectedGroupNames.push('*');
  }
  if (allAdminsGroupId && selectedGroupIds.includes(allAdminsGroupId)) {
    selectedGroupNames.push('ADMINS');
  }

  return selectedGroupNames;
};
